// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

export type ProcessingMaster = {
  materialName: string;
  materialTypes: MaterialType[];
  wasteUnits: WasteUnit[];
};

export type ProcessingMasterParams = {
  materialName: string;
  wasteUnits: WasteUnit[];
};

export type WasteUnit = {
  id: number;
  name?: string;
  processingMasterDetails: ProcessingMasterDetail[];
  site?: {
    id: string;
    name: string;
  };
};

export type ProcessingMasterDetail = {
  rate: string;
  materialTypeId?: number;
  materialType?: MaterialType;
};

export type MaterialType = {
  id: number;
  name: string;
};

export type VisibleColumn = MaterialType & { commonValue?: string };

export enum UpdateRateType {
  AddColumn = 'AddColumn',
  DeleteColumn = 'DeleteColumn',
  ChangeInput = 'ChangeInput',
  SetColumnValue = 'SetColumnValue',
}
